import React from "react";
import { ClientDetailsAndDocumentStep } from "../../../components/ClientDetailsAndDocumentStep";

export const CreateVendorClientDetailsAndInvoiceStep: React.FC = () => {
  return <ClientDetailsAndDocumentStep documentType={"invoice"} />;
};

export default CreateVendorClientDetailsAndInvoiceStep;
